import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField } from '@mui/material';
import { get } from 'lodash';
import { useTranslatedMessages } from '../../hooks/useTranslatedMessages';
import { getDatePickerProviderProps } from '../../utils/datePickerLocale';

export default function SingleDatePicker({
  control,
  name,
  label,
  errors,
  readOnly = false,
  minDate,
  maxDate,
  helperText,
  disabled = false,
  clearable = false,
}) {
  const { language } = useTranslatedMessages();
  const datePickerLocale = getDatePickerProviderProps(language);
  const errorMessage = get(errors, name, {})?.message;
  const combinedHelperText = [helperText, errorMessage].filter(Boolean).join(' * ');

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} {...datePickerLocale}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <DatePicker
            id={name}
            label={label}
            format="DD-MM-YYYY"
            renderInput={(params) => <TextField {...field} fullWidth />}
            onChange={(date) => field.onChange(date)}
            value={field.value}
            readOnly={readOnly}
            minDate={minDate}
            maxDate={maxDate}
            slotProps={{
              field: { clearable: clearable && !readOnly },
              textField: {
                fullWidth: true,
                error: !!errorMessage,
                helperText: combinedHelperText,
                disabled: disabled,
              },
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
}
